import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectCollarType, selectShowInvalids } from '@store/order/selectors';
import { setCollarType } from '@store/order/slice';
import collarWithBuckle from '@assets/images/collar-with-buckle.svg';
import collarWithoutBuckle from '@assets/images/collar-without-buckle.svg';
import { invalidFormValue } from '@components/utils';
import CollapsibleInfo from '@pages/order/collar-type/CollapsibleInfo';
import { CollarTypeEnum } from '@pages/order/collar-type/CollarTypeEnum';



const Patterns = () => {
	const { t } = useTranslation('forms');

	const collarType = useSelector(selectCollarType);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateCollarType = (value: string | null) => dispatch(setCollarType(value));

	return (
		<div className='collar-type-section'>

			<label className='collar-type-label'>
				{t('collarType.sectionLabel') + ' '}<span>*</span> {showInvalids && invalidFormValue(collarType) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<div className='collar-type-elements'>

				<div className='collar-type-element'>
					<div
						className={`collar-type-icon disable-selection${collarType === CollarTypeEnum.withBuckle ? ' active-character' : ''}`}
						onClick={() => updateCollarType(CollarTypeEnum.withBuckle)}>
						<img src={collarWithBuckle} alt='with-buckle-collar-type-icon' draggable={false} />
					</div>
					
					<div className='collar-type-icon-label'>
						<p>{t('collarType.withBuckle')}</p>
					</div>
				</div>


				<div className='collar-type-element'>
					<div
						className={`collar-type-icon disable-selection${collarType === CollarTypeEnum.withoutBuckle ? ' active-character' : ''}`}
						onClick={() => updateCollarType(CollarTypeEnum.withoutBuckle)}>
						<img src={collarWithoutBuckle} alt='without-buckle-collar-type-icon' draggable={false} />
					</div>
					
					<div className='collar-type-icon-label'>
						<p>{t('collarType.withoutBuckle')}</p>
					</div>
				</div>
			
			</div>

			<CollapsibleInfo />
			
		</div>
	);
};

export default Patterns;